import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import HtmlRegion from '../htmlRegion';

class ContactUs extends PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    render() {
        return (
            <div className={styles.box}>
                <h4 className={styles.title}>联系我们</h4>
                <Chip id={25036} type="static" title="联系我们" groupName="联系我们" content={this.props.content}>
                    <HtmlRegion />
                </Chip>
            </div>
        );
    }
}

export default ContactUs;
